import { render, staticRenderFns } from "./screen1.vue?vue&type=template&id=3c564d92&scoped=true&"
import script from "./screen1.vue?vue&type=script&lang=js&"
export * from "./screen1.vue?vue&type=script&lang=js&"
import style0 from "./screen1.vue?vue&type=style&index=0&id=3c564d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c564d92",
  null
  
)

export default component.exports